import { Alert, AlertDescription, AlertIcon } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';

export function UsiVerificationResetWarning({
  usiChanged = false,
  identityChanged = false,
}: {
  usiChanged?: boolean;
  identityChanged?: boolean;
}): React.ReactElement {
  return (
    <Alert status="warning" borderRadius="md" alignItems="flex-start">
      <AlertIcon />
      <AlertDescription>
        {usiChanged && identityChanged ? (
          <Trans>Both the student&apos;s details and their USI have changed.</Trans>
        ) : usiChanged ? (
          <Trans>This is a new, unverified USI.</Trans>
        ) : (
          <Trans>These details no longer match what the USI was verified against.</Trans>
        )}{' '}
        <Trans>
          Saving clears the verified status and blocks the student&apos;s accredited course until
          the USI is verified again.
        </Trans>
      </AlertDescription>
    </Alert>
  );
}
